import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import './css/mobile.css';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { change_Current_Location, changeHeaderTitle } from "../store";
import axios from 'axios';
import { LoadingModal } from './component/modal/modal';

export default function UrlUserHistory() {
    const dispatch = useDispatch();
    const { state } = useLocation();

    // ✅ MidLayout에서 유효성 검증 후 진입 → 여기서는 디코딩만
    const { mid: rawMid } = useParams();
    const mid = rawMid ? decodeURIComponent(rawMid) : "";

    const login = useSelector(s => s.login?.value);

    const fmt = (n) =>
        typeof n === "number"
            ? n.toLocaleString("ko-KR")
            : (Number(n) || 0).toLocaleString("ko-KR");

    // ===== 목업 기본값 =====
    const mock = {
        orderId: "ORD-20250912-0001",
        orderedAt: new Date().toISOString(),
        buyer: {
            name: "강재원(집)",
            tel: "010-7284-7899",
            address1: "경기도 수원시 장안구 장안로 271 (정자동) 115-705",
            postcode: "16336",
        },
        items: [
            {
                merchantName: "보넬드",
                productName: "[100% NFC 토마토 14개 착즙] 보넬드 아이엠 토마토 주스 즙 원액 1L, 3개",
                quantity: 1,
                unitPrice: 23000,
                originalUnit: 23000,
                thumbnail: "https://picsum.photos/id/1080/1200/900",
                optionText: "수량",
            },
        ],
        deliveryFee: 0,
        subtotal: 23000,
        total: 23000,
        payment: {
            method: "신용카드",
            cardMasked: "하나 9416 **** **** ****",
            payType: "일시불",
            email: "wodnjs***@naver.com",
        },
        cashReceipt: { issued: true, type: "소득공제용", info: "010-****-****" },
    };

    // 🔸 API로 교체될 주문 데이터 상태 (초기값은 목업 + (옵션) state.receipt)
    const [orderData, setOrderData] = useState(() => ({
        ...mock,
        ...(state?.receipt || {}),
    }));

    // 상품 표시용 파생 값 (orderData 기반)
    const item = orderData.items?.[0] || {};
    const merchantName = item.merchantName || "가맹점";
    const productName = item.productName || "상품명";
    const quantity = Number(item.quantity ?? 1);
    const unitPrice = Number(item.unitPrice ?? 0);
    const originalUnit = Number(item.originalUnit ?? unitPrice);
    const hasDiscount = originalUnit > unitPrice;
    const prodImg = item.thumbnail || "";
    const totalAmount =
        typeof orderData.total === "number"
            ? orderData.total
            : unitPrice * quantity + (orderData.deliveryFee || 0);

    // 헤더 타이틀
    useEffect(() => {
        dispatch(change_Current_Location("주문완료내역"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "주문완료내역",
                subTitle: orderData.orderId || "",
            })
        );
    }, [dispatch, orderData.orderId]);

    const [loading, setLoading] = useState(false);

    // ===== 인증 게이트 =====
    const [verified, setVerified] = useState(false);
    const [gateName, setGateName] = useState("");
    const [gateOrder, setGateOrder] = useState(""); // ← 사용자가 입력하는 주문번호 = tid
    const [gateError, setGateError] = useState("");

    const handleOrderChange = (e) => {
        // 영문/숫자만 허용
        const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 40);
        setGateOrder(value);
    };

    const normalizeName = (s) =>
        String(s || "").replace(/\(.*?\)/g, "").replace(/\s+/g, "").trim();
    const normalizeOrder = (s) =>
        String(s || "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

    // 🔸 tid로 주문 상세 불러오기
    const loadOrder = async (tid) => {
        if (!tid) return;
        setLoading(true);
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API}/api/orders/${tid}`,
                { withCredentials: true }
            );
            const api = res?.data;
            // 서버 스키마에 맞게 조정 필요 시 여기서 매핑
            // 일단은 mock + (옵션) state.receipt + api.data를 병합
            const merged = {
                ...mock,
                ...(state?.receipt || {}),
                ...(api?.data || {}),
            };
            setOrderData(merged);
        } catch (e) {
            console.error("[GET /api/orders/:tid] failed", e);
            // 실패해도 mock+receipt 상태 유지
        } finally {
            setLoading(false);
        }
    };

    const verify = () => {
        const nameOK =
            normalizeName(gateName) === normalizeName(orderData.buyer?.name) ||
            normalizeName(gateName) ===
            normalizeName(orderData.buyer?.name).replace(/\(.*?\)/g, "");
        const orderOK =
            normalizeOrder(gateOrder) === normalizeOrder(orderData.orderId);

        if (nameOK && orderOK) {
            setVerified(true);
            setGateError("");
            loadOrder(gateOrder); // ✅ 검증 통과 시 입력한 주문번호 = tid로 API 호출
        } else {
            // 검증 로직을 쓰지 않더라도, 실제 사용에서는 아래 라인을 주석 해제 권장
            // setGateError("이름 또는 주문번호가 일치하지 않습니다.");

            // 데모/개발용: 검증 스킵 + 호출
            setVerified(true);
            loadOrder(gateOrder);
        }
    };

    const onGateSubmit = (e) => {
        e.preventDefault();
        verify();
    };

    // 날짜 포맷: 2025.06.06. 20:12:16
    const formatOrderDate = (iso) => {
        const d = new Date(iso);
        if (isNaN(d)) return "";
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        const HH = String(d.getHours()).padStart(2, "0");
        const MM = String(d.getMinutes()).padStart(2, "0");
        const SS = String(d.getSeconds()).padStart(2, "0");
        return `${yyyy}.${mm}.${dd}. ${HH}:${MM}:${SS}`;
    };

    // 게이트 화면
    if (!verified) {
        return (
            <div style={{ background: "#fff" }}>
                <div className="urlUserHistory-gate">
                    <form className="urlUserHistory-gateCard" onSubmit={onGateSubmit}>
                        <h1 className="urlUserHistory-gateTitle">주문내역 확인</h1>

                        <div className="urlUserHistory-gateRow">
                            <label className="urlUserHistory-gateLabel">휴대폰번호</label>
                            <input
                                className="urlUserHistory-gateInput"
                                placeholder="휴대폰번호 입력"
                                value={gateName}
                                onChange={(e) => setGateName(e.target.value)}
                                autoComplete="name"
                            />
                        </div>

                        <div className="urlUserHistory-gateRow">
                            <label className="urlUserHistory-gateLabel">주문번호</label>
                            <input
                                className="urlUserHistory-gateInput"
                                placeholder="주문번호 입력 (영문/숫자)"
                                value={gateOrder}
                                onChange={handleOrderChange}
                                autoComplete="off"
                                inputMode="text"
                                spellCheck={false}
                            />
                        </div>

                        {gateError && (
                            <div className="urlUserHistory-gateError">{gateError}</div>
                        )}

                        <button
                            type="submit"
                            className="urlUserHistory-gateBtn"
                            disabled={!gateName.trim() || !gateOrder.trim()}
                        >
                            확인
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    // 인증 통과 후 상세
    return (
        <div
            style={{
                minHeight: "100dvh",
                height: "100%",
                background: "#f3f5f7",
            }}
        >
            {loading ? <LoadingModal /> : ''}
            <div className="urlUserHistory-wrap">
                {/* 상단: 날짜/주문번호 */}
                <section className="urlUserHistory-section">
                    <div className="urlUserHistory-orderHeader">
                        <div>
                            <div className="urlUserHistory-orderMeta">
                                {formatOrderDate(orderData.orderedAt)}
                            </div>
                            <div className="urlUserHistory-orderNo">
                                주문번호 {orderData.orderId}
                            </div>
                        </div>
                    </div>
                </section>

                {/* 배송지 */}
                <section className="urlUserHistory-section">
                    <h2 className="urlUserHistory-title">배송지</h2>
                    <div className="urlUserHistory-card">
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">받는사람</div>
                            <div className="urlUserHistory-value">{orderData.buyer?.name}</div>
                        </div>
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">연락처</div>
                            <div className="urlUserHistory-value">{orderData.buyer?.tel}</div>
                        </div>
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">우편번호</div>
                            <div className="urlUserHistory-value">{orderData.buyer?.postcode}</div>
                        </div>
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">주소</div>
                            <div className="urlUserHistory-value">{orderData.buyer?.address1}</div>
                        </div>
                    </div>
                </section>

                {/* 주문상품 */}
                <section className="urlPayment-section">
                    <h2 className="urlPayment-title">주문상품</h2>

                    <div className="urlPayment-card card1">
                        <div className="urlPayment-orderHead">
                            <div className="urlPayment-store">{merchantName}</div>
                        </div>

                        <div className="urlPayment-orderBody">
                            <div className="urlPayment-thumb">
                                {prodImg ? (
                                    <img src={prodImg} alt="" className="urlPayment-thumbImg" />
                                ) : null}
                            </div>
                            <div className="urlPayment-info">
                                <div className="urlPayment-prod">{productName}</div>
                            </div>
                        </div>

                        <div className="urlPayment-optsList">
                            <div className="urlPayment-optItem">
                                <div className="urlPayment-optLeft">
                                    <span className="urlPayment-optTag">옵션</span>
                                    <span className="urlPayment-optName">옵션 0</span>
                                    <span className="urlPayment-optQty">{quantity}개</span>
                                </div>
                                <div className="urlPayment-optRight">
                                    {hasDiscount && (
                                        <span className="urlPayment-priceOld">
                                            {fmt(originalUnit * quantity)}원
                                        </span>
                                    )}
                                    <span className="urlPayment-priceNow">
                                        {fmt(unitPrice * quantity)}원
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* 총 주문금액 */}
                        <div className="urlPayment-totalInline">
                            <span className="urlPayment-totalLabel">총 주문금액</span>
                            <b className="urlPayment-totalValue">{fmt(totalAmount)}원</b>
                        </div>
                    </div>
                </section>

                {/* 결제정보 */}
                <section className="urlUserHistory-section">
                    <h2 className="urlUserHistory-title">결제정보</h2>
                    <div className="urlUserHistory-card">
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">결제수단</div>
                            <div className="urlUserHistory-value">{orderData.payment?.method}</div>
                        </div>
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">카드</div>
                            <div className="urlUserHistory-value">
                                {orderData.payment?.cardMasked} <span> | </span> {orderData.payment?.payType}
                            </div>
                        </div>
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">이메일</div>
                            <div className="urlUserHistory-value">{orderData.payment?.email}</div>
                        </div>
                    </div>
                </section>

                {/* 현금영수증 */}
                <section className="urlUserHistory-section">
                    <h2 className="urlUserHistory-title">현금영수증</h2>
                    <div className="urlUserHistory-card">
                        {orderData.cashReceipt?.issued ? (
                            <>
                                <div className="urlUserHistory-row">
                                    <div className="urlUserHistory-label">발급 구분</div>
                                    <div className="urlUserHistory-value">{orderData.cashReceipt?.type}</div>
                                </div>
                                <div className="urlUserHistory-row">
                                    <div className="urlUserHistory-label">발행정보</div>
                                    <div className="urlUserHistory-value">{orderData.cashReceipt?.info}</div>
                                </div>
                            </>
                        ) : (
                            <div className="urlUserHistory-row">
                                <div className="urlUserHistory-label">발급 여부</div>
                                <div className="urlUserHistory-value">발급안함</div>
                            </div>
                        )}
                    </div>
                </section>
            </div>
        </div>
    );
}
